/* tslint:disable */
/* eslint-disable */
/**
 * crm-campaigns
 * crm-campaigns
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { TaskTemplate } from './TaskTemplate';
import {
    TaskTemplateFromJSON,
    TaskTemplateFromJSONTyped,
    TaskTemplateToJSON,
} from './TaskTemplate';

/**
 * 
 * @export
 * @interface CreateTaskTemplate201Response
 */
export interface CreateTaskTemplate201Response {
    /**
     * 
     * @type {TaskTemplate}
     * @memberof CreateTaskTemplate201Response
     */
    data?: TaskTemplate;
}

/**
 * Check if a given object implements the CreateTaskTemplate201Response interface.
 */
export function instanceOfCreateTaskTemplate201Response(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function CreateTaskTemplate201ResponseFromJSON(json: any): CreateTaskTemplate201Response {
    return CreateTaskTemplate201ResponseFromJSONTyped(json, false);
}

export function CreateTaskTemplate201ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateTaskTemplate201Response {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': !exists(json, 'data') ? undefined : TaskTemplateFromJSON(json['data']),
    };
}

export function CreateTaskTemplate201ResponseToJSON(value?: CreateTaskTemplate201Response | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': TaskTemplateToJSON(value.data),
    };
}

